import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { ID } from "@types";
import {
  getServiceProvider,
  IServiceProvider,
} from "../services/serviceProviders";

interface IUseServiceProviderOptions {
  includes: "user"[];
}

export const useServiceProvider = (
  serviceProviderId: ID | undefined,
  options?: IUseServiceProviderOptions
) => {
  const {
    data: serviceProvider,
    isLoading,
    isError,
    isSuccess,
    status,
  } = useDataQuery<IServiceProvider>(
    ["serviceProvider", Number(serviceProviderId), options],
    () =>
      getServiceProvider(serviceProviderId, options).then(({ data }) => data),
    {
      enabled: !!serviceProviderId,
    }
  );

  return { serviceProvider, isLoading, isError, isSuccess, status };
};
